export class WebUserDetails {
  id: string;
  userToken: string;
  userRole: string;
  refreshToken: string;
}
